export default __webpack_public_path__ + "static/media/ph01.aef8565d.png";